import React from "react";
import { Divider } from "@mui/material";
import { Spin } from "antd";
import GlobalDialogBox from "../global/GlobalDialogBox/GlobalDialogBox";
import { FilterBody } from "./components/filterBody/filterBody.index";
import { FilterFooter } from "./components/filterFooter/filterFooter.index";
import { FilterHeader } from "./components/filterHeader/filterHeader.index";
import { FilterPopupProps } from "./filterPopup.models";
import styles from "./filterPopup.module.css";

export const FilterPopup = ({
    isOpen,
    onClose,
    filterOptions,
    onApply,
    isLoading = false,
    title,
}: FilterPopupProps) => (
    <GlobalDialogBox isOpen={isOpen} onClose={onClose} sizeType="sm">
        <div className={styles.filterPopupCtn}>
            {isLoading ? (
                <div className={styles.loadingCtn}>
                    <Spin />
                </div>
            ) : (
                <>
                    <FilterHeader onClose={onClose} title={title} />
                    <Divider />
                    <FilterBody filterOptions={filterOptions} />
                    <FilterFooter onCancelClick={onClose} onApplyClick={onApply} />
                </>
            )}
        </div>
    </GlobalDialogBox>
);